import { render } from "./DecisionTree.vue?vue&type=template&id=3ef79dd2"
import script from "./DecisionTree.vue?vue&type=script&lang=js"
export * from "./DecisionTree.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__